import React,{useState,useEffect} from 'react';
import DataTable from 'react-data-table-component';
import * as RestService from '../../services/eisRest';
import { Button} from 'react-bootstrap';
import FileSaver from 'file-saver';
import LoadingOverlay from 'react-loading-overlay';
import {useTranslation} from 'react-i18next';
import CustomSelect from '../custom-select/CustomSelect';

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

const DataTableDoc = (props) => {

    const [t] = useTranslation();      
    const [url, setUrl] = useState();
    const [data, setData] = useState();
   // const [columns, setColumns] = useState(props.columns);
  //  const [subData, setSubData] = useState();
   // const [subColumns, setSubColumns] = useState(props.columnsSubRow);
    const [loading, setLoading] = useState(false);
    const [exportRunning, setExportRunning] = useState(false);    
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);    
    const [selectedColumn, setSelectedColumn] = useState(1);    
    const [sortDirection, setSortDirection] = useState('asc');        
    const [filterText, setFilterText] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);        
 //   const [modalShow, setModalShow] = useState(props.modalShow);    
  //  const [entitySubName, setEntitySubName] = useState();
    const [entitySpecify, setEntitySpecify] = useState();
    const [specifyOptions, setSpecifyOptions] = useState();
   
    
    
    const warehouseOptions = [
      { value: 'WRH-RCT', label: t('document.label.receivedItems') },
      { value: 'WRH-ISS', label: t('document.label.issuedItems')  },                 
      { value: 'WRH-MVM', label: t('document.label.movedItems')  }, 
    ];

    const orderOptions = [
      { value: 'ORD-RCT', label: t('document.label.receivedOrders') },
      { value: 'ORD-ISS', label: t('document.label.issuedOrders')  },                 
    ];

    const invoiceOptions = [
      { value: 'INV-RCT', label: t('document.label.receivedInvoices') },
      { value: 'INV-ISS', label: t('document.label.issuedInvoices')  },                 
    ];

    const deliveryNoteOptions = [
      { value: 'DLN-RCT', label: t('document.label.receivedDeliveryNotes') },
      { value: 'DLN-ISS', label: t('document.label.issuedDeliveryNotes')  },                 
    ];


    useEffect(() => {      
      let defaultSpecify='';
    //  setEntitySubName(props.entitySubName);
      switch(props.entitySubName){
        case "warehouse":
          setSpecifyOptions(warehouseOptions);
          defaultSpecify='WRH-RCT';        
        break;
        case "order":
          setSpecifyOptions(orderOptions);
          defaultSpecify='ORD-RCT';
        break;
        case "invoice":
          setSpecifyOptions(invoiceOptions);
          defaultSpecify='INV-RCT';
        break;
        case "deliveryNote":
          setSpecifyOptions(deliveryNoteOptions);
          defaultSpecify='DLN-RCT';        
        break;
      }
      setEntitySpecify(defaultSpecify);
      props.parentCallbackEntitySpecify(defaultSpecify);
    }, [props.entitySubName])


    useEffect(() => {      
      setEntitySpecify(props.entitySpecify);     
   }, [props.entitySpecify])

    const customStyles = {
      rows: {
        style: {
        //  fontFamily: "Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif",
          fontSize: '15px'
        }        
      },
      header: {
        style: {
          fontSize: '22px',
          fontWeight: 800
        },
      },     
      headCells: {
        style: {
          fontSize: '17px',
          fontWeight: 800
          
        },
      }
    };


   const handleOnSort = (selectedColumn, sortDirection ) => {
      setSelectedColumn(selectedColumn);
      setSortDirection(sortDirection);
      
      props.columnsData.find(function(item, i){
        
        if(item.data === selectedColumn.data){
          setSelectedColumn(i);
          fetchData(url,currentPage,perPage,i,sortDirection);
        }
      });

      
   }

    
    const fetchData = (url,page, size = perPage, selectedColumn = 1, sortDirection = 'asc', search = '') => {
        if(entitySpecify==undefined || entitySpecify===''){return;}
        setLoading(true);          
             
        RestService.callAnyApi(url+"&entitySpecify="+entitySpecify,{
            columns: props.columnsData,
            order: [{column: selectedColumn,dir: sortDirection}],
            search: {value: search,regex: false},
            draw: page-1,
            length: size,
            start: ((page-1)*size)          
        })
          .then((response) => {          
                  

            setData(response.data);
            setTotalRows(response.recordsFiltered);
            setLoading(false);
          })
          .catch((error) => {               
            setLoading(false);
          });
    
       
      };

      
     
        
    
      useEffect(() => {
        fetchData(1);
      }, []);
    
      useEffect(() => {
        setUrl(props.url);
        fetchData(url,currentPage,perPage,selectedColumn,sortDirection,filterText);
      }, [props.modalShow]);

      useEffect(() => {
        setUrl(props.url);        
        fetchData(props.url,currentPage,perPage,selectedColumn,sortDirection,filterText);
      }, [props.checkTime]);
    
    
      useEffect(() => {
          setUrl(props.url);
          fetchData(props.url,currentPage,perPage,selectedColumn,sortDirection,filterText);
      }, [props.url]);
    

      
      

      const handlePageChange = page => {
        fetchData(page);
        setCurrentPage(page);
        fetchData(url,page, perPage);
      };
    
      const handlePerRowsChange = async (newPerPage, page) => {
        fetchData(url,page, newPerPage);
        setPerPage(newPerPage);
      };

  
      const handleRowClicked = (row) =>{
        //console.log(row);
        props.parentCallback(row.id); 
      }

      const handleItemRowClicked = (row) =>{
        //console.log(row);
        props.parentCallback(row.documentId,row.id); 
      }



     

      const FilterComponent = ( { filterText, onClear, onFilter,specifyOptions,entitySpecify,exportExcel}) => {
       
                return(
                <>       
                  <div  style={{width: '100%'}}>                                
                            <div style={{display: "flex", flexDirection: "col", justifyContent: "flex-end"}}>
                                      <div className="col-6 col-sm-6 col-lg-6 d-flex justify-content-start align-self-center">
                                      <div class="form-group col-4 align-self-center"  style={props.showSelectEntitySpecify ? {} : { display: 'none' }}>                   
                                            <CustomSelect
                                                  className='input'
                                                  onChange={value=>{setEntitySpecify(value.value); props.parentCallbackEntitySpecify(value.value);}}
                                                  value={entitySpecify}
                                                  options={specifyOptions}     
                                            />                                
                                         </div>
                                      </div>
                                      <div className="col-6 col-sm-6 col-lg-6 d-flex justify-content-end align-self-center">
                                          {props.exportShow ?
                                                  <div style={{width: '400px'}}>
                                                    <Button className="btn-default" style={{marginLeft: '10px'}} onClick={exportExcel}>Export to Excel 
                                                        <i className="fas fa-file-excel" style={{marginLeft: '10px'}}></i>
                                                    </Button>
                                                  </div>
                                                    : <></>
                                              }                           
                                                
                                            
                                            <div>
                                                <div className="input-group">
                                                    <div className="form-outline">
                                                        <input  type="text" autoFocus className="form-control" value={filterText} onChange={onFilter}  placeholder={t('general.label.search')}/>   
                                                    </div>
                                                    <Button  onClick={onClear}>
                                                        <i className="fas fa-times"></i>
                                                    </Button>
                                                </div>         


                                            </div>
                                      </div>



                              
                            </div>  
                          

 
                            

                                
                            
                  </div>
                </>
              );
        };

    

      const subHeaderComponentMemo = React.useMemo(() => {
        const handleClear = () => {
          if (filterText) {
            setResetPaginationToggle(!resetPaginationToggle);
            setFilterText('');
          }
        };


        const exportExcel = () =>{
          setExportRunning(true);       
          RestService.downloadExceFile(props.urlExcel+"&entitySpecify="+entitySpecify,{
                columns: props.columnsData,
                order: [{column: selectedColumn,dir: sortDirection}],
                search: {value: filterText,regex: false},
                draw: currentPage-1,
                length: perPage,
                start: ((currentPage-1)*perPage)          
          })
          .then((response) => {       
             //FileDownload(response.data, 'report.xls');   
             FileSaver.saveAs(response.data, 'report.xls');
             setExportRunning(false);       
             // console.log(response);
          })
          .catch((error) => {               
            console.log(error);
            setExportRunning(false);       
          });               

      };

        fetchData(url,currentPage,perPage,selectedColumn,sortDirection,filterText);
       

       
    
        return (
                  <>                   
                  <FilterComponent onFilter={e => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} specifyOptions={specifyOptions} entitySpecify={entitySpecify} exportExcel={exportExcel}/>
                  </>
               );
      }, [filterText, resetPaginationToggle,specifyOptions,entitySpecify]);


      const ExpanableComponent = ({ data, subColumns}) => {             
              return (
                          <DataTable    
                              data={data ? data.documentLines : []}
                              noHeader={true}                                              
                              subHeader={false}                                                
                              columns={subColumns}
                              onRowClicked={handleItemRowClicked} 
                          />
                    );
      };

        return (
          <>
         <LoadingOverlay
  active={exportRunning}
  spinner
  text='Export running...'
  >
  <DataTable
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
              //  subHeader={false}
               // fixedHeader
                title={props.tableName}
                columns={props.columns}
                data={data}                
                progressPending={loading}
                pagination
                paginationServer
                //sortServer         
                paginationComponentOptions={ {rowsPerPageText: 'Rows per page:', rangeSeparatorText: 'of', noRowsPerPage: false, selectAllRowsItem: true, selectAllRowsItemText: 'All' }}
                paginationTotalRows={totalRows}
                paginationDefaultPage={currentPage}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                onSort={handleOnSort}              
               // selectableRows
                highlightOnHover
                onRowClicked={handleRowClicked}                
                onSelectedRowsChange={({ selectedRows }) => console.log(selectedRows)}
                paginationResetDefaultPage={resetPaginationToggle} 
                customStyles={customStyles}

                expandableRows={true}
                expandableRowsComponent={
                <ExpanableComponent subColumns={props.columnsSubRow}/>
              } 
                />
</LoadingOverlay>
           
              
          </>
          
        );
}

export default DataTableDoc;